var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"editableDiv",staticClass:"editable-div",attrs:{"contenteditable":"true"},on:{"click":_vm.triggerEmojiPicker}}),_c('button',{on:{"click":_vm.focusDiv}},[_vm._v("Add Emoji (Use OS Shortcut)")])])}
var staticRenderFns = []

export { render, staticRenderFns }